export const currentPositions = [
  {
    id: "cipet",
    role: "Junior Research Fellow",
    company: "CIPET: SARP - LARPM",
    status: "active",
  },
  {
    id: "dfs",
    role: "Research Intern",
    company: "Deep Forest Sciences",
    status: "active",
  },
  {
    id: "utkal",
    role: "PhD Scholar",
    company: "Utkal University",
    status: "active",
  },
];
